export default __webpack_public_path__ + "logo.a6c4acb72a569755d19c67fa9b0446d6.png";